import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/scott-graham-5fNmWej4tAA-unsplash.jpeg";

function HvaKosterDetALaVaere() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.costOfIgnoring.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.costOfIgnoring.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/hva-koster-det-a-la-vaere"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.costOfIgnoring.title")}
          </h1>
          <p className="text-xl mb-2">
          {i18next.t("pages.articles.list.costOfIgnoring.sections.intro.content1")}
              <a href="/artikler/er-din-bedrift-klar" className="underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.costOfIgnoring.sections.intro.link")}
              </a>
              {i18next.t("pages.articles.list.costOfIgnoring.sections.intro.content2")}
            
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.costOfIgnoring.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5">
          <img
            src={article_img}
            className="w-full"
            alt={i18next.t("pages.articles.list.costOfIgnoring.imageAlt")}
          />
          <p className="text-sm text-secondary mt-2">
            {i18next.t("pages.articles.credit.photoBy")}{" "}
            <a
              href="https://unsplash.com/@amstram?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Scott Graham
            </a>{" "}
            {i18next.t("pages.articles.credit.from")}{" "}
            <a
              href="https://unsplash.com/photos/person-holding-pencil-near-laptop-computer-5fNmWej4tAA?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Unsplash
            </a>
          </p>
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
          

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.costOfIgnoring.sections.legal.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.costOfIgnoring.sections.legal.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.costOfIgnoring.sections.sanctions.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.costOfIgnoring.sections.sanctions.content")}
             <b> {i18next.t("pages.articles.list.costOfIgnoring.sections.sanctions.eur")}</b>
              {i18next.t("pages.articles.list.costOfIgnoring.sections.sanctions.content2")}

            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.costOfIgnoring.sections.financial.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.costOfIgnoring.sections.financial.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.costOfIgnoring.sections.reputation.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.costOfIgnoring.sections.reputation.content1")}
              <a href="/artikler" className="underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.costOfIgnoring.sections.reputation.link")}
              </a>
              {i18next.t("pages.articles.list.costOfIgnoring.sections.reputation.content2")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.costOfIgnoring.sections.moreThanLaw.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.costOfIgnoring.sections.moreThanLaw.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.costOfIgnoring.sections.conclusion.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.costOfIgnoring.sections.conclusion.content")}</p>

            <p className="mt-6">
                <a href="/skjema/kontakt-oss" className="font-bold underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.costOfIgnoring.sections.cta.cta")}
                </a>
              {i18next.t("pages.articles.list.costOfIgnoring.sections.cta.ctaFollow")}
              <a href="/docengine" className="font-bold underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.costOfIgnoring.sections.cta.link")}
              </a>
              {i18next.t("pages.articles.list.costOfIgnoring.sections.cta.content")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HvaKosterDetALaVaere;



